import React from 'react';
import { Waves } from 'lucide-react';

const TONE = {
    bear: 'border-rose-500/40 bg-rose-500/10 text-rose-200',
    bull: 'border-emerald-500/40 bg-emerald-500/10 text-emerald-200',
    neutral: 'border-slate-600 bg-slate-800/60 text-slate-300',
};

export default function RegimeBadge({ regime }) {
    if (!regime || regime.breadth_pct === null || regime.breadth_pct === undefined) return null;
    const tone = TONE[regime.regime] || TONE.neutral;
    return (
        <div
            data-testid="regime-badge"
            title={regime.advice_tr}
            className={`flex items-start gap-2 rounded-md border px-3 py-2 text-[11px] leading-snug ${tone}`}
        >
            <Waves className="h-3.5 w-3.5 shrink-0 mt-px" />
            <div className="min-w-0">
                <div className="font-semibold" data-testid="regime-label">{regime.label_tr}</div>
                <div className="text-[10px] opacity-80" data-testid="regime-advice">{regime.advice_tr}</div>
            </div>
        </div>
    );
}
